import I18n from '@/i18n/config';

import type { IByggKontraktItem } from './IByggKontraktItem';

export class ByggKontraktItem implements IByggKontraktItem {
    public static parseObject(obj: IByggKontraktItem): ByggKontraktItem {
        try {
            return new ByggKontraktItem(obj);
        } catch (error) {
            throw new Error(
                `Not able to parse KontraktItem object, object attempted to parse is: ${JSON.stringify(
                    obj,
                )}`,
            );
        }
    }

    public get amount() {
        return this._amount;
    }
    public get areaTypeName() {
        return this._areaTypeName;
    }
    public get areal() {
        return this._areal;
    }
    public get byggNummer() {
        return this._byggNummer;
    }
    public get contractLineName() {
        return this._contractLineName;
    }
    public get kontraktId() {
        return this._kontraktId;
    }
    public get kontraktNummer() {
        return this._kontraktNummer;
    }
    public get kundeNavn() {
        return this._kundeNavn;
    }
    public get kundeNummer() {
        return this._kundeNummer;
    }
    public get objectId() {
        return this._objectId;
    }
    public get rentalCosttypeName() {
        return this._rentalCosttypeName;
    }
    public get rentalQty() {
        return this._rentalQty;
    }
    public get rentalobjectName() {
        return this._rentalobjectName;
    }
    public get validFrom() {
        return this._validFrom;
    }
    public get validTo() {
        return this._validTo;
    }

    public get pricePerM2() {
        return this._pricePerM2;
    }
    public get pricePerM2Unit() {
        return this._pricePerM2Unit;
    }
    public get pricePerPlace() {
        return this._pricePerPlace;
    }
    public get arealUnits() {
        return this._arealUnits;
    }
    public get lokalValuta() {
        return this._lokalValuta;
    }

    public get arealIkkeMedregnet() {
        return this._arealIkkeMedregnet;
    }
    public get fristOppsigelseLeietaker() {
        return this._fristOppsigelseLeietaker;
    }
    public get fristOppsigelseUtleier() {
        return this._fristOppsigelseUtleier;
    }

    private _amount: number;
    private _areaTypeName: string;
    private _areal: number | string;
    private _byggNummer: string;
    private _contractLineName: string;
    private _kontraktId: number;
    private _kontraktNummer: string;
    private _kundeNavn: string;
    private _kundeNummer: string;
    private _objectId: number;
    private _rentalCosttypeName: string;
    private _rentalQty: number;
    private _rentalobjectName: string;
    private _validFrom: Date;
    private _validTo: Date;

    private _pricePerM2: string | number = '-';
    private _pricePerM2Unit: string;
    private _pricePerPlace: string | number = '-';
    private _arealUnits = 'm²';
    private _lokalValuta: string;

    private _arealIkkeMedregnet: boolean;
    private _fristOppsigelseLeietaker?: Date;
    private _fristOppsigelseUtleier?: Date;

    constructor(obj: IByggKontraktItem) {
        this._amount = obj.amount;
        this._areaTypeName = obj.areaTypeName || 'other';
        this._areal = obj.areal;
        this._byggNummer = obj.byggNummer;
        this._contractLineName = obj.contractLineName;
        this._kontraktId = obj.kontraktId;
        this._kontraktNummer = obj.kontraktNummer;
        this._kundeNavn = obj.kundeNavn;
        this._kundeNummer = obj.kundeNummer;
        this._objectId = obj.objectId;
        this._rentalCosttypeName = obj.rentalCosttypeName;
        this._rentalQty = obj.rentalQty;
        this._rentalobjectName = obj.rentalobjectName;
        this._validFrom = new Date(obj.validFrom);
        this._validTo = new Date(obj.validTo);
        this._lokalValuta = obj.lokalValuta;
        this._arealIkkeMedregnet = obj.arealIkkeMedregnet;
        this._fristOppsigelseLeietaker = obj.fristOppsigelseLeietaker
            ? new Date(obj.fristOppsigelseLeietaker)
            : undefined;
        this._fristOppsigelseUtleier = obj.fristOppsigelseUtleier
            ? new Date(obj.fristOppsigelseUtleier)
            : undefined;

        if (Number(this._areal) > 0) {
            this._pricePerM2 =
                this._amount / parseInt(this._areal.toString(), 10);
            this._pricePerM2Unit = I18n.t('kontrakt.prisPerAar');
        } else {
            this._areal = '-';
            this._arealUnits = '';
        }
        if (this._rentalQty > 0) {
            this._pricePerPlace = this._amount / this._rentalQty;
        }
    }

    public get belop(): number {
        return this._amount;
    }

    public get erBelop(): boolean {
        return (this.belop as number) > 0;
    }
}
